import React from "react";
import CategoryTeam from "../CategoryTeam";
import { productTeamProfile } from "../DevelopmentTeam/DevelopmentTeamImg";

const DevelopmentTeam = () => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 text-center gap-11 ">
      {productTeamProfile.map((category: any) => (
        <CategoryTeam key={category.id} ourTeam={category} />
      ))}
    </div>
  );
};

export default DevelopmentTeam;
